const deviationNotificaionType = {
  Shipment_Num_Creation: 1,
  TruckIn: 2,
  TruckOut: 3,
  Material_Quantity: 4,
  Material_Invoice_Creation: 5,
  Reached_At: 6,
  Vehicle_Assignment_At: 7,
};

const deviationNotificaionFields = {
  TRUCK_IN: 'TRUCK_IN',
  TRUCK_OUT: 'TRUCK_OUT',
  REACH_AT: 'REACH_AT',
  VEHICLE_ASSIGNMENT_AT: 'VEHICLE_ASSIGNMENT_AT',
  SHIPMENT_NUMBER_CREATION: 'SHIPMENT_NUMBER_CREATION',
  MATERIAL_INVOICE_CREATION: 'MATERIAL_INVOICE_CREATION',
  MATERIAL_QUANTITY: 'MATERIAL_QUANTITY',
};

module.exports = { deviationNotificaionType, deviationNotificaionFields };
